export const isSuccessStatus = (statusCode) => {
  return RegExp(/^2[0-9]{2}$/u).test(String(statusCode))
}
